import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
    getApplicationMatrixList_action, updateShortlistFinalistMatrix_action
} from "../../../actions/adminModule_action/matrix_action";
import { responseError, scoringRoundActionId, seq_noActionId, awardCategoryActionId, award_event_id, toastError, toastSuccess } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import Footer from "../../../common_components/Footer";
import { fill_action } from "../../../actions/common_action/fillList_action";
import { Modal } from "react-bootstrap";
import * as XLSX from "xlsx";
import MobileHeader from "../../../common_components/mobileHeader";

class AdminApplicationMatrix extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            user_id: "",
            role_id: "",
            Name: "",
            Description: "",
            is_active: "",
            applicationMatrixData: [],
            filteredData: [],
            statusFillList: [],
            isAccordionExpanded: false,
            currentPage: 1,
            shortlistNumber: '',
            finalistNumber: '',
            roundName: '',
            scoringRoundList: [],
            noOfShortlist: 1,
            seq_noList: [],
            categoryId: '',
            categoryList: [],
            isRound1Enable: false,
            isRound2Enable: false,
            isOpen: false,
            matrixType: '',
            noOfWinner: 1,
            categoryName: '',
            shortlistFlag: false,
            winnerFlag: false,
        };
        this.navigateApplication = this.navigateApplication.bind(this);
        this.getapplicationMatrixData = this.getapplicationMatrixData.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.updateItem = this.updateItem.bind(this);
    }
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }

        setTimeout(() => {
            {
                sessionStorage.getItem("role_id") == 2 ? (
                    this.props.navigate("/login")
                ) : <></>
            }
        }, 10);
        const { user_id } = this.state;
        this.setState({
            user_id:
                sessionStorage.getItem("user_id") == "" ||
                    sessionStorage.getItem("user_id") == null
                    ? ""
                    : sessionStorage.getItem("user_id"),
        });
        this.getFillList(scoringRoundActionId, sessionStorage.getItem("user_id"), "", "");
        this.getFillList(seq_noActionId, sessionStorage.getItem("user_id"), "", "");
        this.getFillList(awardCategoryActionId, sessionStorage.getItem("user_id"), "", sessionStorage.getItem("award_event_id"));
        ;
    }

    getFillList(value, user_id, keyword, keyvalue) {
        this.setState({ isLoading: true });
        this.props
            .fill_action(
                value,
                user_id == "" || user_id == null ? null : user_id,
                keyword != "" ? keyword : null,
                keyvalue != "" ? keyvalue : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (value == scoringRoundActionId) {
                        this.setState({
                            scoringRoundList: data.data,
                        });
                    }
                    if (value == seq_noActionId) {
                        this.setState({
                            seq_noList: data.data,
                        });
                    }
                    if (value == awardCategoryActionId) {
                        this.setState({
                            categoryList: data.data,
                        });
                    }
                    this.setState({ isLoading: false })
                } else {
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getapplicationMatrixData() {
        const { roundName, categoryId, } = this.state;
        if (categoryId != '') {
            if (roundName != '') {
                this.setState({ isLoading: true });
                this.props
                    .getApplicationMatrixList_action(categoryId, roundName)
                    .then((data) => {
                        if (data.error !== 1) {
                            if (data.data != '' && data.data != undefined) {
                                this.setState({
                                    applicationMatrixData: data.data,
                                    isLoading: false,
                                    isRound2Enable: true,
                                    currentpage: 1,
                                });
                                const shortlistFlag = data.data.some(item => item.application_status_id == 8)
                                const winnerFlag = data.data.some(item => item.application_status_id == 9)
                                this.setState({ shortlistFlag: shortlistFlag, winnerFlag: winnerFlag })
                                if (roundName == 'Round 1') {
                                    this.setState({
                                        isRound1Enable: true,
                                        isRound2Enable: false,
                                    });
                                } else {
                                    this.setState({
                                        isRound1Enable: false,
                                        isRound2Enable: true,
                                    });
                                }
                            } else {
                                this.setState({ isLoading: false, applicationMatrixData: [], isRound2Enable: true });
                            }
                        } else {
                            this.setState({ isLoading: false });
                            responseError(data);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            } else {
                toastError("Please select Round")
            }
        } else {
            toastError("Please select category")
        }
    }

    updateShortlistFinalistMatrix(type) {
        const { roundName, categoryId, matrixType, applicationMatrixData, noOfShortlist, noOfWinner } = this.state;
        var applicationNoArray = []
        var applicationWinnerList = []
        if (matrixType == 'Shortlist') {
            applicationNoArray = applicationMatrixData.slice(0, noOfShortlist).map(item => item.application_form_id);
        } else if (matrixType == 'Winner') {
            applicationNoArray = applicationMatrixData.slice(0, noOfWinner).map(item => item.application_form_id);
            applicationWinnerList = applicationMatrixData.slice(0, noOfWinner);
        } else {
            applicationNoArray = applicationMatrixData.map(item => item.application_form_id);
            applicationWinnerList = applicationMatrixData;
        }
        const matrixList = []
        if (matrixType == 'Winner' || matrixType == 'Update') {
            applicationWinnerList.map(item => {
                matrixList.push({
                    "applicant_scoring_id": item.applicant_scoring_id,
                    "application_form_id": item.application_form_id,
                    "award_event_id": award_event_id,
                    "award_event_profile_id": categoryId,
                    "scoring_pattern_id": '0',
                    "section_id": '0',
                    "score": item['Round 2'] != '' && item['Round 2'] != 0 ? item['Round 2'] : '0',
                    "max_score": '0',
                    "calculate_score": item['Round 2'] != '' && item['Round 2'] != 0 ? item['Round 2'] : '0',
                })
            })
        }
        this.setState({ isLoading: true });
        this.props
            .updateShortlistFinalistMatrix_action(categoryId, applicationNoArray.join(), matrixType, matrixList)
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({
                        isLoading: false,
                        isOpen: false
                    });
                    toastSuccess('data updated successfully')
                    this.getapplicationMatrixData()
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    navigateRoleAdd() {
        this.props.navigate("/roleAU", {
            state: { role_id: 0 },
        });
    }
    navigateApplication(role_id) {
        this.props.navigate(`/roleAU`, {
            state: { role_id: role_id },
        });
    }

    clearFilters() {
        const { Name, Status } = this.state;
        this.setState({
            roundName: "",
            categoryId: "",
            applicationMatrixData: []
        });
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }

    updateRowValue = (rowId, updatedValue) => {
        this.setState(prevState => {
            const applicationMatrixData = prevState.applicationMatrixData.map(item => {
                if (item.application_form_id === rowId) {
                    if (updatedValue <= item.Round2_Max_Score) {
                        const round1Score = Number(item['Round 1']) || 0;
                        const round2Score = updatedValue !== '' ? Number(updatedValue) : 0;
                        const totalScore = (round1Score + round2Score).toFixed(2); // Ensure correct decimal places

                        return {
                            ...item,
                            'Round 2': round2Score,
                            'TOTAL SCORE': parseFloat(totalScore) // Convert back to number
                        };
                    } else {
                        toastError(`Can not enter score more than ${item.Round2_Max_Score}`);
                        return {
                            ...item,
                            'Round 2': '',
                            'TOTAL SCORE': parseFloat(Number(item['Round 1']).toFixed(2))
                        };
                    }
                }
                return item;
            });

            return { applicationMatrixData };
        });
    };



    matrixRecords(applicationMatrixData) {
        const { roundName, isRound1Enable, isRound2Enable, shortlistFlag, winnerFlag } = this.state;
        const excludedColumns = ['application_form_id', 'application_status_id', 'Round2_Max_Score', 'applicant_scoring_id'];

        // Filter headers to exclude specific columns
        const headers = applicationMatrixData?.length > 0
            ? Object.keys(applicationMatrixData[0]).filter(header => !excludedColumns.includes(header))
            : [];

        return (
            <>
                <table className="table table-bordered" id="dashboard-table">
                    <thead>
                        <tr>
                            {headers?.map((header, index) => (
                                <th key={index} style={{ textAlign: header == 'TOTAL SCORE' ? 'right' : '' }}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {applicationMatrixData?.length > 0 ? (
                            applicationMatrixData?.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {headers.map((header, colIndex) => (
                                        <td key={colIndex} style={{ width: header == 'Round 2' ? '22%' : '', textAlign: header == 'TOTAL SCORE' ? 'right' : '' }}>
                                            {colIndex === 0 ? (
                                                <>
                                                    {row['application_status_id'] === 8 ? (
                                                        <>
                                                            <i className="ri-star-fill" />&nbsp;&nbsp;
                                                        </>
                                                    ) : row['application_status_id'] === 9 ? (
                                                        <>
                                                            <i className="ri-vip-crown-2-fill" />&nbsp;&nbsp;
                                                        </>
                                                    ) : (
                                                        <>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        </>
                                                    )}
                                                    {(row[header] != null || row[header] != "") ? row[header] : '-'}
                                                </>
                                            ) : (
                                                <>
                                                    {(header === 'Round 2') ? (
                                                        <input
                                                            className="form-control"
                                                            value={row[header] || ''}
                                                            maxLength={3}
                                                            onChange={(e) => {
                                                                const updatedValue = e.target.value?.replace(/\D/, '');
                                                                this.updateRowValue(row.application_form_id, updatedValue);
                                                            }}
                                                        />
                                                    ) : (
                                                        <>
                                                            {row[header] !== null && row[header] !== "" && !isNaN(Number(row[header]))
                                                                ? Number(row[header]).toFixed(2)
                                                                : "-"
                                                            }
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <td colSpan={headers.length} className="text-center">
                                No records found
                            </td>
                        )}
                    </tbody>
                </table>
            </>
        );
    }

    handleChange = (e, type) => {
        const value = e.target.value;
        const regex = /^[0-9]*$/;
        if (regex.test(value)) {
            if (type == 's') {
                this.setState({ shortlistNumber: value });
            } else if (type == 'f') {
                this.setState({ finalistNumber: value });
            }
        }
    };

    exportToExcelWithTitle = (data, fileName, title, excludeKeys = []) => {
        if (!data || data.length === 0) {
            console.error("No data available to export");
            return;
        }

        // Filter out excluded keys dynamically
        const headers = Object.keys(data[0]).filter((key) => !excludeKeys.includes(key));

        // Add the title row
        const titleRow = [title];

        // Convert headers and data into rows for SheetJS
        const headerRow = headers; // Use filtered keys as headers
        const dataRows = data.map((row) =>
            headers.map((key) => row[key] || "") // Include only non-excluded keys
        );

        // Combine title, headers, and data
        const worksheetData = [titleRow, [], headerRow, ...dataRows];

        // Create a new worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Merge the title row to span all columns
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
        ];

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Write the workbook to a file and trigger download
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };


    render() {
        const {
            isLoading,
            applicationMatrixData,
            currentPage,
            isAccordionExpanded,
            Name, shortlistNumber, finalistNumber, noOfWinner, matrixType, categoryName,
            roundName, scoringRoundList, noOfShortlist, seq_noList, categoryId, categoryList, shortlistFlag, winnerFlag } = this.state;
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = applicationMatrixData?.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(applicationMatrixData?.length / recordsPerPage);

        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>
                        {/* <Header data={[20]} /> */}
                        <section class='header_margin_top'>
                            <div className="container-fluid">

                                <div className="page-header">
                                    <h2 className="mb-3 dashboard-tit  py-0 blog-name blog-name-1">Application Matrix</h2>
                                    {applicationMatrixData.length > 0 &&
                                        <button
                                            onClick={() => this.exportToExcelWithTitle(applicationMatrixData, roundName, categoryName, ['application_form_id', 'application_status_id', 'Round2_Max_Score', 'applicant_scoring_id'])}
                                            className="btn btn-outline-warning mr-2">
                                            Export
                                        </button>}
                                </div>
                                <div className="row">
                                    <div className="col-6 mb-5">
                                        <label>Category<span className="mendatory_class">*</span></label>
                                        <select
                                            className="form-select"
                                            name="TimeSlot"
                                            value={categoryId}
                                            onChange={(e) => {
                                                const selectedId = parseInt(e.target.value);
                                                const selectedCategory = categoryList.find(
                                                    (data) => data.award_event_profile_id === selectedId
                                                );
                                                const selectedName = selectedCategory ? selectedCategory.award_name : '';
                                                this.setState({
                                                    categoryId: selectedId,
                                                    categoryName: selectedName,
                                                });
                                            }}
                                        >
                                            <option value={''}>Select</option>
                                            {categoryList.filter(data => data.publish_status == 1).map((data) => (
                                                <option
                                                    key={data.award_event_profile_id}
                                                    value={data.award_event_profile_id}
                                                >
                                                    {data.award_name}
                                                </option>
                                            ))}
                                        </select>


                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{roundNameErr}</span>} */}
                                    </div>
                                    <div className="col-2 mb-3">
                                        <label>Round <span className="mendatory_class">*</span></label>
                                        <select
                                            className="form-select"
                                            name="TimeSlot"
                                            value={roundName}
                                            onChange={(e) => {
                                                this.setState({
                                                    roundNameErr: '',
                                                    roundName: e.target.value,
                                                }
                                                    // () => { this.getFillList(28, this.state.user_id, e.target.value, "")}; 
                                                )
                                            }}
                                        >
                                            <option value={''}>Select</option>
                                            {scoringRoundList.map((data) => (
                                                <option
                                                    key={data.round_name}
                                                    value={data.round_name}
                                                >
                                                    {data.round_name}
                                                </option>
                                            ))}
                                        </select>
                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{roundNameErr}</span>} */}
                                    </div>
                                    <div className="col-2 mb-3">
                                        <label></label>
                                        <button
                                            onClick={() => this.getapplicationMatrixData()}
                                            className="btn btn-outline-primary mr-2">
                                            View
                                        </button>
                                        <button
                                            onClick={this.clearFilters}
                                            className="btn btn-outline-danger clr_btn">
                                            Clear
                                        </button>
                                    </div>
                                    <div className="col-2 mb-3 text-right">
                                        <label></label>
                                        <span className="mr-4"><i class="ri-star-fill"></i> Shortlist</span>
                                        <span><i class="ri-vip-crown-2-fill"></i> Winner</span>
                                    </div>
                                </div>
                                {/* <div class="eligibility-container1">
                                        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form
                                    </div>
                                    <div class="eligibility-container2 my-2">
                                        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form
                                    </div> */}

                                <div className="custom_table">
                                    <div className="hack1">
                                        <div className="hack2">
                                            {this.matrixRecords(currentRecords)}
                                            {applicationMatrixData?.length > 0 ? (
                                                <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem}
                                                />
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {/* {applicationMatrixData?.length > 0 ? <> */}
                                {applicationMatrixData.length > 0 &&
                                    <>
                                        {!winnerFlag && this.state.isRound2Enable &&
                                            <div class="badge-row">
                                                <button class="btn btn-outline-primary search_btn w-auto"
                                                    onClick={() => this.setState({ isOpen: true, matrixType: 'Update' })} style={{ padding: '3px 5px' }}>Update Round 2</button>
                                            </div>
                                        }
                                        {/* <div class="badge-container">
                                            {(winnerFlag ? !winnerFlag : !shortlistFlag) &&
                                                <div class="badge-row">
                                                    <span class="badge-shortlist" onClick={() => this.setState({ isOpen: true, matrixType: 'Shortlist' })}>Shortlist</span>
                                                    <span class="badge-text">top <span class="badge-highlight">
                                                        <select
                                                            name="TimeSlot"
                                                            className="form-select badge-highlight-seq_no"
                                                            value={noOfShortlist}
                                                            onChange={(e) => {
                                                                this.setState({
                                                                    noOfShortlist: e.target.value,
                                                                })
                                                            }}
                                                        >
                                                            {seq_noList.map((data) => (
                                                                <option
                                                                    key={data.seq_no}
                                                                    value={data.seq_no}
                                                                >
                                                                    {data.seq_no}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </span> for Next Round.</span>
                                                </div>
                                            }
                                            {!winnerFlag &&
                                                <>
                                                    <div class="badge-row">
                                                        <span class="badge-finalist" onClick={() => this.setState({ isOpen: true, matrixType: 'Winner' })}>Winner</span>
                                                        <span class="badge-text">top <span class="badge-highlight">
                                                            <select
                                                                name="TimeSlot"
                                                                className="form-select badge-highlight-seq_no"
                                                                value={noOfWinner}
                                                                onChange={(e) => {
                                                                    this.setState({
                                                                        noOfWinner: e.target.value,
                                                                    })
                                                                }}
                                                            >
                                                                {seq_noList.map((data) => (
                                                                    <option
                                                                        key={data.seq_no}
                                                                        value={data.seq_no}
                                                                    >
                                                                        {data.seq_no}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </span> for Winner.</span>
                                                    </div>
                                                </>
                                            }
                                        </div> */}
                                    </>
                                }
                                {/* </> : <></>} */}
                            </div>
                        </section>
                    </main >

                    <Modal show={this.state.isOpen}>
                        <Modal.Header>
                            <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                {/* <div > */}
                                <h6> {matrixType} Application </h6>
                                {/* </div> */}
                            </Modal.Title>
                            <span
                                onClick={() => this.setState({ isOpen: false })}
                                style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                            >
                                X
                            </span>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                {matrixType != 'Update' ?
                                    <p className="mb-1 mt-1 com-font" style={{}}>
                                        Do you really want to {matrixType} top {matrixType == 'Shortlist' ? noOfShortlist : noOfWinner} applicant ?<br />
                                        <div className="text-danger mt-2 d-flex" style={{ lineHeight: '18px' }}>
                                            <p style={{ width: '100px', fontSize: '15px', margin: '0' }}> Note : </p><p style={{ fontSize: '15px', margin: '0' }}>   If you click "Yes" the top {matrixType == 'Shortlist' ? noOfShortlist : noOfWinner} applicants will be {matrixType}, even if all juries have not assigned marks to every applicant.</p>
                                        </div>
                                    </p> :
                                    <p className="mb-1 mt-1 text-center com-font">
                                        Do you really want to update applicant score ?
                                    </p>
                                }
                                {/* <p className="mb-1 mt-1 text-center com-font">
                                    After submission you will not be able to change the fields
                                </p> */}
                            </div>
                        </Modal.Body>

                        <Modal.Footer style={{ justifyContent: 'left' }}>
                            <div class="row">
                                <div class="col-md-12">
                                    <button
                                        onClick={() => this.updateShortlistFinalistMatrix()}
                                        class="btn btn-warning mr-2"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        Yes
                                    </button>
                                    <button
                                        onClick={() => this.setState({ isOpen: false })}
                                        class="btn btn-dark"
                                        style={{ cursor: 'pointer', width: 'auto' }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>

                        </Modal.Footer>
                    </Modal>

                    <Footer />
                    <ToastContainer />
                </>
            </>
        );
    }
}
export default withRouter(
    connect(null, { getApplicationMatrixList_action, updateShortlistFinalistMatrix_action, fill_action })(AdminApplicationMatrix)
);
